/* lib/assistantAccess.js — право участника пользоваться Аргусом (№523). ЧИСТАЯ логика.

   Источник — поле `assistant.allowed` пространства (`GET /api/auth/workspaces/`, бэкенд
   `accounts.views._workspace_dict`): роль или личное исключение закрыли ключ
   «Аргус: пользоваться» (`assistant.use`). Владелец и администраторы — всегда да. Поля нет
   (старый бэкенд, демо, пространство не загрузилось) — открыто: решает всегда сервер,
   любой запрос к Аргусу без права — 403 `{code: 'assistant_forbidden'}`. Здесь — чтобы не
   показывать пункт меню и кнопки, которые сервер отклонит. */

export const ASSISTANT_FORBIDDEN_CODE = 'assistant_forbidden';
// Подпись выключенных пунктов «Редактировать в чате» и экрана закрытого чата — без точки
// в конце; detail сервера приходит с ней.
export const ASSISTANT_CLOSED_TEXT = 'Доступ к Аргусу закрыт администратором пространства';

export function canUseAssistant(workspace) {
  const a = workspace && workspace.assistant;
  return !(a && a.allowed === false);
}

// Право АКТИВНОГО пространства для мест вне React-контекста (пункты «⋮» реестров «Продукции»
// собираются функцией конфигурации). Ставит AuthProvider при каждом рендере; по умолчанию — да.
let currentAllowed = true;

export function setAssistantAllowed(allowed) {
  currentAllowed = allowed !== false;
}

/** Причина выключенного пункта «Редактировать в чате» или undefined, если Аргус открыт. */
export function assistantClosedReason() {
  return currentAllowed ? undefined : ASSISTANT_CLOSED_TEXT;
}
